import 'aos/dist/aos.css';
import React, { lazy, useEffect } from 'react'
import { BrowserRouter as Router, Switch, Redirect, Route } from 'react-router-dom'
import AccessibleNavigationAnnouncer from './components/AccessibleNavigationAnnouncer'
import ProtectedRoute from './components/Routes/ProtectedRoute'
import ForwardRoute from './components/Routes/ForwardRoute'
import Layouts from './components/Layout'
import AOS from 'aos';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import PlatFormTools from './pages/PlatFormTools';
import LearningBook from './pages/LearningBook';

const Layout = lazy(() => import('./containers/Layout'))
const Auth = lazy(() => import('./containers/Auth'))
const Landing = lazy(() => import('./pages/Landing'))
const About = lazy(() => import('./pages/About'))
const Platform_E = lazy(() => import('./pages/Platform_E'))
const WhyUs = lazy(() => import('./pages/WhyUS'))
const AccountType = lazy(() => import('./pages/AccountType'))
const Funding = lazy(() => import('./pages/Funding'))
const Contact = lazy(() => import('./pages/Contact'))
const Offers = lazy(() => import('./pages/Offers'))
const EconomicCalender = lazy(() => import('./pages/EconomicCalender'))
const CandleChart = lazy(() => import('./pages/CandleChart'))
const LivePrice = lazy(() => import('./pages/LivePrice'))
const RiskDisclosure = lazy(() => import('./pages/RiskDisclosure'))
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'))

const EmailVerification = lazy(() => import('./pages/EmailVerification'))


const RouteData =[
  {
    links:"/",
    compo:Landing
  },
  {
    links:"/about",
    compo:About
  },
  {
    links:"/platform",
    compo:Platform_E
  },
  {
    links:"/whyus",
    compo:WhyUs
  },
  {
    links:"/trading/account-type",
    compo:AccountType
  },
   {
    links:"/trading/platform-tools",
    compo:PlatFormTools
  },
  {
    links:"/trading/funding",
    compo:Funding
  },
  {
    links:"/contact",
    compo:Contact
  },
  {
    links:"/learning-book",
    compo:LearningBook
  },
  {
    links:"/referral",
    compo:Offers
  },
  {
    links:"/charts/economic-calender",
    compo:EconomicCalender
  },
  {
    links:"/charts/candle-charts",
    compo:CandleChart
  },
  {
    links:"/charts/live-price",
    compo:LivePrice
  },  
  {
    links:"/risk-disclosure",
    compo:RiskDisclosure
  },  
  {
    links:"/terms-&-conditions",
    compo:TermsAndConditions
  },  
]
function App() {

  return (
    <>
      <Router>
        <AccessibleNavigationAnnouncer />
        <Switch>
          <ForwardRoute path="/auth" component={Auth} />
          {/* Place new routes over this */}
          <ProtectedRoute path="/app" component={Layout} />
          <Route exact path="/verify-email" component={EmailVerification} />
          <Layouts>
            {
              RouteData.map((i,key)=>{
                  return(
                    <Route key={key} exact path={i?.links} component={i?.compo} />
                  )
              })
            }
          </Layouts>
          
          <Redirect from="*" to="/" />
        </Switch>
      </Router>
    </>
  )
}

export default App
